import React from 'react';
import classnames from 'classnames';
import Element from '../../../element';
import styles from '../card.module.scss';

interface IProps {
    className?: string;
}

export default function CardHeaderTitle({ className, ...props }: IProps) {
    return (
        <Element
            {...props}
            className={classnames(styles['card-header-title'], className)}
        />
    );
}
